module.exports = __webpack_public_path__ + "img/celery.a2051b87.svg";